import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  root: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(16),
    minHeight: rh(64),
    paddingLeft: rw(16),
    paddingRight: rw(4),
    paddingVertical: rh(8),
    flexDirection: 'row',
    alignItems: 'center',
    gap: rw(4),
  },
  content: { flex: 1, minWidth: 0, overflow: 'hidden' },
  copy: { width: rw(40), height: rw(40), alignItems: 'center', justifyContent: 'center' },
}))
